


















import { Component, Vue } from 'vue-property-decorator';
import FormHeader from '@/app/common/component/FormHeader.vue';
import RegisterForm from '@/app/auth/register/RegisterForm.vue';
import HeaderImg from '@/app/common/component/HeaderImg.vue';

@Component({
  name: 'AfterRegisterContainer',
  components: { FormHeader, RegisterForm, HeaderImg },
})
export default class RegisterContainer extends Vue {
  get logoUrl(): string | null {
    return this.$store.getters.logoUrl;
  }
}
